module.exports = __webpack_public_path__ + "img/动态贴纸--多种款式gif.76b352f1.gif";